<!-- Nội Dung Chính -->
<div class="container mt-4">
    <!-- Tiêu đề với biểu tượng -->
    <h1 class="h3 mb-2 text-gray-800">
      <i class="fas fa-file-invoice-dollar mr-2"></i>Hóa Đơn
    </h1>

    <!-- Mô tả dưới tiêu đề -->
    <p class="lead mb-4">
      Quản lý và xem hóa đơn của bạn một cách hiệu quả. Sử dụng các tab để truy cập các phần khác nhau, bao gồm một tổng quan về các chỉ số hóa đơn, một danh sách đầy đủ các hóa đơn, và hướng dẫn người dùng. Nút "Thêm Hóa Đơn" cho phép bạn thêm các hóa đơn mới vào hệ thống.
    </p>

    <!-- Tab Điều Hướng -->
    <ul class="nav nav-tabs">
      <li class="nav-item">
        <a class="nav-link active" data-toggle="tab" href="#List">
          <i class="fas fa-list mr-2"></i> Danh Sách
        </a>
      </li>
      <li class="nav-item">
        <a class="nav-link" data-toggle="tab" href="#UserManual">
          <i class="fas fa-book mr-2"></i> Hướng Dẫn Sử Dụng
        </a>
      </li>
    </ul>

    <!-- Nội Dung Tab -->
    <div class="tab-content">
      <!-- Nội dung tab Danh Sách -->
      <div id="List" class="tab-pane fade show active">
        <div class="container-fluid" style="background-color: white;">
          <!-- Nút kích hoạt modal -->
          <button class="btn btn-outline-primary mb-3" (click)="openAddDialog()">Thêm Hóa Đơn</button>
          <button
          href="#"
          role="button"
          class="btn btn-outline-warning btn-icon-split"
          (click)="loadInvoices()"
        >
          <span class="icon text-warning">
            <i class="fas fa-redo"></i>
          </span>
          <span class="text">Tải Lại</span>
        </button>

          <!-- Bảng Hóa Đơn -->
          <div class="card mb-4">
            <div class="card-body">
              <div class="table-responsive">
                <div *ngIf="loadingIndicator; else loaded">
                  <div class="d-flex justify-content-center">
                    <div class="spinner-border text-primary" role="status">
                      <span class="sr-only">Đang tải...</span>
                    </div>
                  </div>
                </div>

                <ng-template #loaded>
                  <ngx-datatable
                  class="bootstrap"
                  [rows]="invoices"
                  [columnMode]="'force'"
                  [headerHeight]="50"
                  [footerHeight]="50"
                  [rowHeight]="'auto'"
                  [limit]="10"
                  [loadingIndicator]="loadingIndicator"
                  [reorderable]="reorderable"
                  (select)="onSelect($event)"
                  (activate)="onActivate($event)">

                  <!-- Số Hóa Đơn -->
                  <ngx-datatable-column name="Số Hóa Đơn" [prop]="'invoiceNumber'">
                    <ng-template ngx-datatable-cell-template let-row="row">
                     <span style="color: red;">{{ row.invoiceNumber }}</span> 
                    </ng-template>
                  </ngx-datatable-column>

                  <!-- Ngày Hóa Đơn -->
                  <ngx-datatable-column name="Ngày Hóa Đơn" [prop]="'invoiceDate'">
                    <ng-template ngx-datatable-cell-template let-row="row">
                      {{ row.invoiceDate | date }}
                    </ng-template>
                  </ngx-datatable-column>

                  <!-- Nhà Cung Cấp -->
                  <ngx-datatable-column name="Nhà Cung Cấp" [prop]="'vendor.name'">
                    <ng-template ngx-datatable-cell-template let-row="row">
                      <span style="color: blue;">{{ row.vendor?.name }}</span>
                    </ng-template>
                  </ngx-datatable-column>

                  <!-- Tổng Số Tiền -->
                  <ngx-datatable-column name="Tổng Số Tiền" [prop]="'totalAmount'">
                    <ng-template ngx-datatable-cell-template let-row="row">
                      {{ row.totalAmount | currency }}
                    </ng-template>
                  </ngx-datatable-column>

                  <!-- Ghi Chú -->
                  <ngx-datatable-column name="Ghi Chú" [prop]="'notes'">
                    <ng-template ngx-datatable-cell-template let-row="row">
                      {{ row.notes }}
                    </ng-template>
                  </ngx-datatable-column>

                  <!-- Hành Động -->
                  <ngx-datatable-column name="Hành Động">
                    <ng-template ngx-datatable-cell-template let-row="row">
                      <button type="button" class="btn btn-outline-primary btn-sm dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                          Hành Động
                      </button>
                      <div class="dropdown-menu">
                          <a class="dropdown-item"  (click)="openEditDialog(row)">
                              <i class="fas fa-edit"></i> Chỉnh Sửa
                          </a>
                          <a class="dropdown-item"  (click)="deleteInvoice(row.id)">
                              <i class="fas fa-trash"></i> Xóa
                          </a>
                          <a  [class.disabled]="true"  class="dropdown-item" (click)="download()">
                              <i class="fas fa-file-download"></i> Tải Xuống 
                          </a>
                          <a  [class.disabled]="true"  class="dropdown-item" (click)="pay()">
                              <i class="fas fa-money-bill-wave"></i> Thêm Thanh Toán
                          </a>
                      </div>
                    </ng-template>
                  </ngx-datatable-column>

                </ngx-datatable>
                </ng-template>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Nội dung tab Hướng Dẫn Sử Dụng -->
      <div id="UserManual" class="tab-pane fade" style="background-color: white;">
        <div>
           <div  [innerHTML]="markdownContent"></div>
       </div>
      </div>
    </div>
  </div>

  <!-- Modal cho Biểu Mẫu Thông Tin Hóa Đơn -->
  <div class="modal fade" id="invoiceFormModal" tabindex="-1" aria-labelledby="invoiceFormModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-lg">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="invoiceFormModalLabel">Biểu Mẫu Thông Tin Hóa Đơn</h5>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Đóng"></button>
        </div>
        <div class="modal-body">
          <form action="#" method="post">
            <div class="form-group">
              <label for="invoiceNumber">Số Hóa Đơn:</label>
              <input type="text" class="form-control" id="invoiceNumber" name="invoiceNumber" required>
            </div>
            <div class="form-group">
              <label for="shipmentDate">Ngày Giao Hàng:</label>
              <input type="date" class="form-control" id="shipmentDate" name="shipmentDate" required>
            </div>
            <div class="form-group">
              <label for="billingDate">Ngày Lập Hóa Đơn:</label>
              <input type="date" class="form-control" id="billingDate" name="billingDate" required>
            </div>
            <div class="form-group">
              <label for="shippingCost">Chi Phí Vận Chuyển:</label>
              <input type="number" class="form-control" id="shippingCost" name="shippingCost" step="0.01" required>
            </div>
            <div class="form-group">
              <label for="shippingFund">Quỹ Vận Chuyển:</label>
              <input type="number" class="form-control" id="shippingFund" name="shippingFund" step="0.01" required>
            </div>
            <div class="form-group">
              <label for="status">Trạng Thái:</label>
              <select class="form-control" id="status" name="status">
                <option value="open">Mở</option>
                <option value="close">Đóng</option>
              </select>
            </div>
            <div class="form-check">
              <input type="checkbox" class="form-check-input" id="showInactive" name="showInactive">
              <label class="form-check-label" for="showInactive">Hiển Thị Không Hoạt Động</label>
            </div>
            <button type="submit" class="btn btn-primary mt-3">Gửi</button>
          </form>
        </div>
      </div>
    </div>
  </div>
